import { StorageDecoder, StorageEncoder, StorageService } from './web-storage.model';
import { STORAGE_TRANSCODERS } from './web-storage.utils';

export class WebStorage implements StorageService {
  constructor(private readonly storage: Storage) {}

  get<T = unknown>(key: string, decoder: StorageDecoder<T> = STORAGE_TRANSCODERS.JSON): T | undefined {
    const value = this.getItem(key);

    return value !== undefined ? decoder.decode(value) : undefined;
  }

  set<T = unknown>(key: string, value: T, encoder: StorageEncoder<T> = STORAGE_TRANSCODERS.JSON): void {
    this.setItem(key, encoder.encode(value));
  }

  has(key: string): boolean {
    return this.storage.getItem(key) !== null;
  }

  remove(key: string): void {
    try {
      this.storage.removeItem(key);
    } catch (err) {
      // @ts-expect-error it just logs the error message
      // eslint-disable-next-line no-console
      console.error(`[${WebStorage.name}] > storage remove failed with`, err?.message);
    }
  }

  clear(): void {
    try {
      this.storage.clear();
    } catch (err) {
      // @ts-expect-error it just logs the error message
      // eslint-disable-next-line no-console
      console.error(`[${WebStorage.name}] > storage clear failed with`, err?.message);
    }
  }

  private getItem(key: string): string | undefined {
    try {
      const value = this.storage.getItem(key);

      return value !== null ? value : undefined;
    } catch (err) {
      // @ts-expect-error it just logs the error message
      // eslint-disable-next-line no-console
      console.error(`[${WebStorage.name}] > storage get failed with`, err?.message);
      return undefined;
    }
  }

  private setItem(key: string, value: string): void {
    try {
      this.storage.setItem(key, value);
    } catch (err) {
      // @ts-expect-error it just logs the error message
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      // eslint-disable-next-line no-console
      console.error(`[${WebStorage.name}] > storage set failed with`, err?.message);
    }
  }
}
